export const MAX_ATTEMPTS_TO_CONNECT_BEFORE_CHECK_AUTH_STATUS = 30;